import styled from "styled-components"
import { Subline } from "../../lib/src/components/Typography"

export default styled(Subline)`
  text-align: center;
`
